// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__nGn0J","search":"Settings_search__21kJ0","filter":"Settings_filter__1a51Z"};